/* Brevo Back-In-Stock helper — posts to the server-side proxy.
 *
 * Sends POST {proxyUrl}/back-in-stock with { email, productId }. The proxy
 * holds the Brevo API key and forwards to Brevo's product-alert endpoint,
 * POST /v3/products/{id}/alerts/back_in_stock, which registers the email as
 * a stock-alert subscriber for that product. When inventory replenishes
 * (synced by the PushOwl/Brevo Shopify app), Brevo sends the alert.
 *
 * Docs: https://developers.brevo.com/reference/create-product-alert
 *
 * The Brevo API key is NEVER exposed here. Storefront JS is public, so the
 * key stays server-side behind the proxy; this file only knows the proxy URL
 * (settings.brevo_proxy_url, rendered in layout/theme.liquid).
 *
 * Usage:
 *   window.bodiskinBrevoBIS.submit({
 *     email, productId, // these two are required
 *     source, productHandle, productTitle, variantId  // logged only, not sent
 *   });
 * Returns a Promise<boolean>: true on 2xx, false otherwise. Callers
 * fire-and-forget (no await). */
(function () {
  var ENDPOINT_PATH = '/back-in-stock';
  var LOG = '[BrevoBIS]';

  /* Mirrors the proxy's server-side validation so bad input fails fast here
   * instead of costing a round trip. The server is still authoritative. */
  var MAX_EMAIL_LEN = 254;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PRODUCT_ID_RE = /^[A-Za-z0-9_-]{1,64}$/;

  console.log(LOG, 'helper script loaded');
  console.log(LOG, 'window.bodiskinBrevoConfig =', window.bodiskinBrevoConfig);

  function getConfig() {
    return window.bodiskinBrevoConfig || {};
  }

  function describeFailure(status) {
    if (status === 401 || status === 403) return 'Proxy rejected the request (origin or auth).';
    if (status === 404) return 'Product not found in Brevo, or proxy route missing. The PushOwl/Brevo Shopify app may not have synced this product yet.';
    if (status === 400) return 'Alert could not be created (check product ID / email format).';
    if (status === 429) return 'Rate limited by the proxy.';
    return 'Unexpected error.';
  }

  function submit(payload) {
    console.group(LOG, 'submit() called');
    console.log('payload:', payload);

    payload = payload || {};
    var email = (payload.email || '').trim();
    var productId = payload.productId ? String(payload.productId).trim() : '';

    if (!email) {
      console.warn(LOG, 'no email — aborting');
      console.groupEnd();
      return Promise.resolve(false);
    }
    if (email.length > MAX_EMAIL_LEN || !EMAIL_RE.test(email)) {
      console.warn(LOG, 'email failed validation — aborting');
      console.groupEnd();
      return Promise.resolve(false);
    }
    if (!productId) {
      console.warn(LOG, 'no productId — alert endpoint is product-scoped, aborting');
      console.groupEnd();
      return Promise.resolve(false);
    }
    if (!PRODUCT_ID_RE.test(productId)) {
      console.warn(LOG, 'productId failed validation (expected 1-64 chars of [A-Za-z0-9_-]):', productId);
      console.groupEnd();
      return Promise.resolve(false);
    }

    var config = getConfig();
    console.log(LOG, 'config snapshot:', { proxyUrl: config.proxyUrl || '(empty)' });

    if (!config.proxyUrl) {
      console.warn(LOG, 'proxyUrl missing in window.bodiskinBrevoConfig — aborting');
      console.groupEnd();
      return Promise.resolve(false);
    }

    var url = config.proxyUrl.replace(/\/+$/, '') + ENDPOINT_PATH;
    var body = { email: email, productId: productId };

    console.log(LOG, 'POST', url);
    console.log(LOG, 'request body:', body);
    console.groupEnd();

    return fetch(url, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        console.log(LOG, 'response status:', res.status, res.statusText);
        if (res.ok) {
          console.log(LOG, '✓ stock alert registered (status', res.status + ')');
          return res.json().catch(function () { return null; }).then(function (data) {
            if (data) console.log(LOG, 'response body:', data);
            return true;
          });
        }
        return res
          .json()
          .catch(function () { return { message: '(no body)' }; })
          .then(function (err) {
            console.warn(LOG, '✗ API ' + res.status + ':', describeFailure(res.status));
            console.warn(LOG, 'error body:', err);
            return false;
          });
      })
      .catch(function (err) {
        console.warn(LOG, 'fetch threw:', err);
        return false;
      });
  }

  window.bodiskinBrevoBIS = { submit: submit };
  console.log(LOG, 'window.bodiskinBrevoBIS.submit is ready');
})();
